import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import { Provider } from "react-redux";
// import { store, persistedStore } from "./redux/store";
import { store } from "./redux/store";
import { setupInterceptors } from './utils/api';
import { ThemeProvider } from "@mui/material";
import theme from "./theme/newtheme";
import { NotificationProvider } from "./components/shared/NotificationProvider";

// import { PersistGate } from "redux-persist/integration/react";

// Set up the interceptors with the store
setupInterceptors(store);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    {/* <PersistGate loading={null} persistor={persistedStore}> */}
    <ThemeProvider theme={theme}>
      <NotificationProvider>
        <App />
      </NotificationProvider>
    </ThemeProvider>
    {/* </PersistGate> */}
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
